import JSConfetti from 'js-confetti';

export function showMotion() {
  const jsConfetti = new JSConfetti();

  // jsConfetti.addConfetti();
  jsConfetti.addConfetti({
    emojis: ['🌈', '⚡️', '💥', '✨', '💫', '🌸'],
  });

  jsConfetti.addConfetti({
    confettiColors: [
      '#ff0a54',
      '#ff477e',
      '#ff7096',
      '#ff85a1',
      '#fbb1bd',
      '#f9bec7',
    ],
  });

  jsConfetti.addConfetti({
    confettiRadius: 6,
  });

  jsConfetti.addConfetti({
    confettiRadius: 6,
    confettiNumber: 500,
  });

  jsConfetti.addConfetti({
    emojis: ['🦄'],
    emojiSize: 100,
    confettiNumber: 30,
  });

  setTimeout(() => {
    jsConfetti.clearCanvas();
  }, 10000);
}
